import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Grid2,
  Box,
} from "@mui/material";
import VideoCall from "@mui/icons-material/VideoCall"; // Ensure this import exists
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";

function KeyDiscussions() {
  const previousMeetingsList = [
    {
      title: "Payment Issues",
      discussionTopics: [
        {
          description:
            "Are there any internal or external challenges impacting your payment schedules?​",
        },
        {
          description:
            "How can we support you in addressing these payment delays?​",
        },
        {
          description:
            " Are there any upcoming payments that you foresee being at risk of delay?​",
        },
      ],
    },
    {
      title: "Tailored Financial Solutions",
      discussionTopics: [
        {
          description:
            "Would you be open to discussing a revised payment plan or structured repayment schedule?​",
        },
        {
          description:
            "Are there any upcoming projects or investments that may require additional financial products or services?​",
        },
      ],
    },
    {
      title: "Actionable Steps",
      discussionTopics: [
        {
          description:
            "Are there any immediate concerns or needs that we should address following this meeting?​",
        },
        {
          description:
            "Can we schedule a follow-up meeting to review potential solutions and progress on current issues?​",
        },
      ],
    },
  ];

  return (
    <div style={{ height: "40vh", overflowY: "auto" }} className="pt-1 px-2">
      <Box>
      <div className="text-xs text-gray-500 italic flex justify-end mr-2">
          <span className="border-b-2 border-t-2 border-gray-500">
            {" "}
            Illustrative
          </span>
        </div>
        {previousMeetingsList.map((item, index) => (
          <Box key={index}>
            <Card className="mb-4 shadow-md">
              <CardContent>
                <Box className="mt-4">
                  <div className="text-sm font-bold my-2">{item.title}</div>
                  <ul className="list-disc ml-6 text-gray-600">
                    {item.discussionTopics.map((topic, topicIndex) => (
                      <li key={topicIndex} className="text-xs">
                        {topic.description}
                      </li>
                    ))}
                  </ul>
                </Box>
              </CardContent>
            </Card>
          </Box>
        ))}
      </Box>
    </div>
  );
}

export default KeyDiscussions;
